/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 決算統計コンバーター変換結果ステータス
 */
export type ConvertResultsStatus = (typeof ConvertResultsStatus)[keyof typeof ConvertResultsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConvertResultsStatus = {
  processing: 'processing',
  success: 'success',
  failed: 'failed',
} as const;
